var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "unified-navigation-ui": "static-1.26364",
      "ably-hubspot-js": "static-2.3199",
      "breadcrumbs-ui": "static-1.1550",
      "client-types": "static-1.370",
      "enviro": "static-4.293",
      "head-dlb": "static-1.3679",
      "hs-lodash": "static-4.45",
      "hs-promise-utils": "static-1.4130",
      "hs-test-utils": "static-1.6621",
      "hub-http": "static-1.4807",
      "hubspot-url-utils": "static-1.3000",
      "HubStyleTokens": "static-2.10106",
      "I18n": "static-7.1370",
      "jasmine-runner": "static-1.5012",
      "nav-client-types": "static-1.1050",
      "nav-meta": "static-1.25157",
      "navigation-components": "static-1.13520",
      "navigation-components-tests": "static-1.10130",
      "navigation-messaging": "static-1.2847",
      "quartz": "static-1.5370",
      "react": "static-7.151",
      "react-dnd": "static-2.33",
      "react-dnd-html5-backend": "static-2.10",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "rpc-client-utils": "static-1.3346",
      "target-element-observer": "static-1.795",
      "webpack-env": "static-1.54",
      "wootric-nps": "static-1.5574",
      "ably": "static-2.2",
      "calling-internal-common": "static-1.29810",
      "classnames": "static-2.10",
      "crosstab": "static-1.3235",
      "ExtensionInstallHelpers": "static-1.526",
      "foundations-components": "static-1.5781",
      "foundations-theming": "static-1.2928",
      "foundations-theming-base": "static-1.1913",
      "foundations-theming-specialty": "static-1.645",
      "frontend-preferences-client": "static-1.6493",
      "global-search-externals": "static-1.10405",
      "idb-keyval": "static-1.20",
      "magpie-lib": "static-1.4297",
      "magpie-types": "static-1.3757",
      "metrics-js": "static-1.8389",
      "nav-onboarding-tours": "static-1.2075",
      "notification-sounds": "static-1.3056",
      "prefetcher": "static-1.4374",
      "react-dom": "static-7.85",
      "react-utils": "static-2.4174",
      "redux-thunk": "static-2.43",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.6806",
      "simple-logging-lib": "static-1.1660",
      "styled-components": "static-2.40",
      "superstore": "static-1.3397",
      "trial-components-library": "static-1.10603",
      "ts-schema": "static-1.2986",
      "ui-images": "static-2.805",
      "usage-tracker-core": "static-1.5932",
      "hs-promise-rejection-tracking": "static-1.3967",
      "PortalIdParser": "static-2.272",
      "raven": "static-3.4440",
      "raven-hubspot": "static-1.4747",
      "bend-plugin-trellis-migration": "static-1.2288",
      "moment": "static-3.26",
      "quartz-core": "static-1.4589",
      "HeadJS": "static-2.563",
      "framer-motion": "static-1.40",
      "hs-test-utils-bend-plugin": "static-1.1732",
      "msw": "static-1.39",
      "testing-library": "static-1.120",
      "i18n-data": "static-1.196",
      "moment-timezone": "static-5.51",
      "jasmine": "static-4.2967",
      "quartz-core-utils": "static-1.2237",
      "StyleGuideUI": "static-3.453",
      "csstype": "static-1.38",
      "hoist-non-react-statics": "static-3.9",
      "quick-fetch": "static-1.2772",
      "HubStyle": "static-2.10415",
      "calling-error-reporting": "static-1.29816",
      "calling-usage-tracker": "static-1.5121",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "self-service-api": "static-1.8807",
      "SharedI18nStrings": "static-1.162",
      "UIComponents": "static-3.7055",
      "bend-plugin-foundations-components": "static-1.2049",
      "floating-ui": "static-1.28",
      "foundations-assets": "static-1.3535",
      "hs-story-utils": "static-1.8006",
      "react-aria": "static-1.38",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.73",
      "tanstack-table": "static-1.23",
      "ui-fonts": "static-1.331",
      "bend-plugin-foundations-theming": "static-1.1411",
      "hub-http-janus": "static-1.635",
      "global-search-shared": "static-1.11118",
      "usage-tracker": "static-1.6082",
      "autolinker": "static-3.11",
      "sanitize": "static-1.2986",
      "transmute": "static-2.29",
      "ai-components-ui-library": "static-1.4979",
      "atom": "static-1.3860",
      "copilot-toolkit": "static-1.5573",
      "demographics-client": "static-1.4035",
      "hubs-service-types": "static-1.63",
      "icons": "static-2.591",
      "laboratory-lib": "static-3.5874",
      "onboarding-scopes": "static-1.5159",
      "react-input-autosize": "static-2.17",
      "salesImages": "static-1.498",
      "signup-constants": "static-1.15852",
      "trials-service-types": "static-1.2692",
      "ui-addon-i18n": "static-1.9531",
      "ui-addon-upgrades": "static-9.15766",
      "user-context": "static-1.3773",
      "dispatcher": "static-1.111",
      "general-store": "static-6.20",
      "history": "static-4.47",
      "hub-http-shared-msw-handlers": "static-1.6842",
      "hubspotter-http": "static-1.3409",
      "hubspotter-http-shared-msw-handlers": "static-1.6840",
      "mobile-manifest-mixins": "static-1.334",
      "platform-navigation-bootstrap": "static-1.11010",
      "react-rhumb": "static-1.15217",
      "react-router-dom": "static-5.26",
      "cssUtils": "static-1.457",
      "customer-data-ui-utilities": "static-1.8352",
      "ai-addon-copilot-preview": "static-1.4191",
      "apollo-link-hub-http": "static-2.3404",
      "apollo-stack-hubspot": "static-3.43",
      "data-fetching-client": "static-1.8218",
      "graphql": "static-1.58",
      "search-service-types": "static-1.2661",
      "chatspot-client-types": "static-1.8340",
      "chatspot-core": "static-1.14807",
      "ContentUtils": "static-1.62571",
      "sassPrefix": "static-1.129",
      "foundations-components-test-utils": "static-1.3266",
      "feature-store-service-types": "static-1.3284",
      "growth-monetization-service-types": "static-1.3291",
      "upgrade-management-service-types": "static-1.3275",
      "getting-started-shared-tasks": "static-1.11476",
      "getting-started-shared-tasks-store": "static-1.10594",
      "platform-infra-nav-components": "static-1.6534",
      "react-dnd-compat": "static-1.3257",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "ai-settings-ui-library": "static-1.5662",
      "apollo-dlb": "static-3.41",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.3397",
      "content-icons-ui": "static-1.1863",
      "underscore": "static-1.8",
      "ui-addon-avatars": "static-2.8053",
      "ui-addon-react-router-dom": "static-1.8231",
      "usage-tracker-container": "static-1.6072"
    },
    "depPathPrefixes": {
      "unified-navigation-ui": "/unified-navigation-ui/static-1.26364",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3199",
      "breadcrumbs-ui": "/breadcrumbs-ui/static-1.1550",
      "client-types": "/client-types/static-1.370",
      "enviro": "/enviro/static-4.293",
      "head-dlb": "/head-dlb/static-1.3679",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hs-promise-utils": "/hs-promise-utils/static-1.4130",
      "hs-test-utils": "/hs-test-utils/static-1.6621",
      "hub-http": "/hub-http/static-1.4807",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3000",
      "HubStyleTokens": "/HubStyleTokens/static-2.10106",
      "I18n": "/I18n/static-7.1370",
      "jasmine-runner": "/jasmine-runner/static-1.5012",
      "nav-client-types": "/nav-client-types/static-1.1050",
      "nav-meta": "/nav-meta/static-1.25157",
      "navigation-components": "/navigation-components/static-1.13520",
      "navigation-components-tests": "/navigation-components-tests/static-1.10130",
      "navigation-messaging": "/navigation-messaging/static-1.2847",
      "quartz": "/quartz/static-1.5370",
      "react": "/react/static-7.151",
      "react-dnd": "/react-dnd/static-2.33",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "rpc-client-utils": "/rpc-client-utils/static-1.3346",
      "target-element-observer": "/target-element-observer/static-1.795",
      "webpack-env": "/webpack-env/static-1.54",
      "wootric-nps": "/wootric-nps/static-1.5574",
      "ably": "/ably/static-2.2",
      "calling-internal-common": "/calling-internal-common/static-1.29810",
      "classnames": "/classnames/static-2.10",
      "crosstab": "/crosstab/static-1.3235",
      "ExtensionInstallHelpers": "/ExtensionInstallHelpers/static-1.526",
      "foundations-components": "/foundations-components/static-1.5781",
      "foundations-theming": "/foundations-theming/static-1.2928",
      "foundations-theming-base": "/foundations-theming-base/static-1.1913",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.645",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.6493",
      "global-search-externals": "/global-search-externals/static-1.10405",
      "idb-keyval": "/idb-keyval/static-1.20",
      "magpie-lib": "/magpie-lib/static-1.4297",
      "magpie-types": "/magpie-types/static-1.3757",
      "metrics-js": "/metrics-js/static-1.8389",
      "nav-onboarding-tours": "/nav-onboarding-tours/static-1.2075",
      "notification-sounds": "/notification-sounds/static-1.3056",
      "prefetcher": "/prefetcher/static-1.4374",
      "react-dom": "/react-dom/static-7.85",
      "react-utils": "/react-utils/static-2.4174",
      "redux-thunk": "/redux-thunk/static-2.43",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.6806",
      "simple-logging-lib": "/simple-logging-lib/static-1.1660",
      "styled-components": "/styled-components/static-2.40",
      "superstore": "/superstore/static-1.3397",
      "trial-components-library": "/trial-components-library/static-1.10603",
      "ts-schema": "/ts-schema/static-1.2986",
      "ui-images": "/ui-images/static-2.805",
      "usage-tracker-core": "/usage-tracker-core/static-1.5932",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.3967",
      "PortalIdParser": "/PortalIdParser/static-2.272",
      "raven": "/raven/static-3.4440",
      "raven-hubspot": "/raven-hubspot/static-1.4747",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2288",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.4589",
      "HeadJS": "/HeadJS/static-2.563",
      "framer-motion": "/framer-motion/static-1.40",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1732",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.120",
      "i18n-data": "/i18n-data/static-1.196",
      "moment-timezone": "/moment-timezone/static-5.51",
      "jasmine": "/jasmine/static-4.2967",
      "quartz-core-utils": "/quartz-core-utils/static-1.2237",
      "StyleGuideUI": "/StyleGuideUI/static-3.453",
      "csstype": "/csstype/static-1.38",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "HubStyle": "/HubStyle/static-2.10415",
      "calling-error-reporting": "/calling-error-reporting/static-1.29816",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.5121",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "self-service-api": "/self-service-api/static-1.8807",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.162",
      "UIComponents": "/UIComponents/static-3.7055",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2049",
      "floating-ui": "/floating-ui/static-1.28",
      "foundations-assets": "/foundations-assets/static-1.3535",
      "hs-story-utils": "/hs-story-utils/static-1.8006",
      "react-aria": "/react-aria/static-1.38",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.73",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-fonts": "/ui-fonts/static-1.331",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1411",
      "hub-http-janus": "/hub-http-janus/static-1.635",
      "global-search-shared": "/global-search-shared/static-1.11118",
      "usage-tracker": "/usage-tracker/static-1.6082",
      "autolinker": "/autolinker/static-3.11",
      "sanitize": "/sanitize/static-1.2986",
      "transmute": "/transmute/static-2.29",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.4979",
      "atom": "/atom/static-1.3860",
      "copilot-toolkit": "/copilot-toolkit/static-1.5573",
      "demographics-client": "/demographics-client/static-1.4035",
      "hubs-service-types": "/hubs-service-types/static-1.63",
      "icons": "/icons/static-2.591",
      "laboratory-lib": "/laboratory-lib/static-3.5874",
      "onboarding-scopes": "/onboarding-scopes/static-1.5159",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "salesImages": "/salesImages/static-1.498",
      "signup-constants": "/signup-constants/static-1.15852",
      "trials-service-types": "/trials-service-types/static-1.2692",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.9531",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.15766",
      "user-context": "/user-context/static-1.3773",
      "dispatcher": "/dispatcher/static-1.111",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.47",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6842",
      "hubspotter-http": "/hubspotter-http/static-1.3409",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6840",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.334",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11010",
      "react-rhumb": "/react-rhumb/static-1.15217",
      "react-router-dom": "/react-router-dom/static-5.26",
      "cssUtils": "/cssUtils/static-1.457",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8352",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.4191",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3404",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
      "data-fetching-client": "/data-fetching-client/static-1.8218",
      "graphql": "/graphql/static-1.58",
      "search-service-types": "/search-service-types/static-1.2661",
      "chatspot-client-types": "/chatspot-client-types/static-1.8340",
      "chatspot-core": "/chatspot-core/static-1.14807",
      "ContentUtils": "/ContentUtils/static-1.62571",
      "sassPrefix": "/sassPrefix/static-1.129",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.3266",
      "feature-store-service-types": "/feature-store-service-types/static-1.3284",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3291",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3275",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.11476",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.10594",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6534",
      "react-dnd-compat": "/react-dnd-compat/static-1.3257",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.5662",
      "apollo-dlb": "/apollo-dlb/static-3.41",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.3397",
      "content-icons-ui": "/content-icons-ui/static-1.1863",
      "underscore": "/underscore/static-1.8",
      "ui-addon-avatars": "/ui-addon-avatars/static-2.8053",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8231",
      "usage-tracker-container": "/usage-tracker-container/static-1.6072"
    },
    "project": "unified-navigation-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};